<template>
<div class="chapter">
<div class="inner_page">
<section aria-label="Title Page">
<div class="ipadfp"><span aria-label="page iii" id="page_iii" role="doc-pagebreak"><img alt="A Hero for WondLa, by Tony DiTerlizzi, illustrated by Tony DiTerlizzi, S&amp;S Books for Young Readers" class="imagefp" src="e9781442450844/images/title.jpg"/></span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?2ab3b9e0